import moment from 'moment';

const FORMAT_DATE = 'MM/DD/YYYY';

export const dateToMMDoYYYY = (date) => moment(new Date(date)).format('MMM Do, YYYY');

export const format = (date, formatDate = FORMAT_DATE) =>
  moment(new Date(date)).format(formatDate);
